import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/ShieldIllustration.tsx
const ShieldIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "shield.svg",
		alt: t("illustration.imageAlt.dataSecurity")
	});
};

//#endregion
export { ShieldIllustration };